import { getAccessToken, setAccessToken } from './cookies.ts';
import { isTokenValid } from './jwt.ts';

/**
 * Session handoff from the MBC extension: a `token` search
 * param carrying a raw JWT seeds the `X-Access-Token` cookie when the browser
 * has no valid session of its own. An existing valid session always wins.
 *
 * This module runs as an import side effect and MUST stay the first import of
 * `main.tsx`: the URL has to be rewritten before New Relic and PostHog
 * initialize (both capture the page URL) and before the router or the `mt`
 * magic-link handler parse the search params.
 */
const TOKEN_PARAM = 'token';
const MAGIC_TOKEN_PARAM = 'mt';

function ingestAccessTokenFromUrl(): void {
  const url = new URL(window.location.href);
  const token = url.searchParams.get(TOKEN_PARAM);

  if (token === null) {
    return;
  }

  url.searchParams.delete(TOKEN_PARAM);

  /**
   * An existing valid session is respected — the handoff only authenticates a
   * browser without a working session. A malformed or expired URL token is
   * ignored the same way, so a stale link falls through to the normal
   * cookie/login flow.
   */
  if (!isTokenValid(getAccessToken()) && isTokenValid(token)) {
    setAccessToken(token);

    /**
     * `mt` is only stripped when the URL token is consumed: a surviving `mt`
     * would be redeemed by the Home loader and overwrite the session written
     * above. When the URL token is ignored, the magic-link flow keeps its
     * normal behavior.
     */
    url.searchParams.delete(MAGIC_TOKEN_PARAM);
  }

  window.history.replaceState(window.history.state, '', url);
}

ingestAccessTokenFromUrl();
